import getElementMap from "../../assets/elements/__elementMap";
import { getImportedTemplateSettings } from '../../assets/creator/template';

/**
 * Matches <Templates>...</Templates>, $1 is the content
 */
const TemplatesTagRegex = /<Templates>([\s\S]+?)<\/Templates>/;

/** 
 * Matches <Templates arg1='aa' {...} Name='path/to/templateWith.ext' argN='..' ... >
 * $3 matches template's Name arg
 */
const SingleTemplateRegex = /<Template\s+[^>]*?\sName=(["'])([^"'>]+?)\1[^>]*?>/g;

/**
 * Matches element includes (as defined by creator), $1 is path, $2 is optional include With (in creator element.name)
 */
const LiquidIncludeElementRegex = /{%-?\s+include\s+'(elements\/[^']+)'(?:\s*with\s+([^,%]+))?(?:\s*,\s*([^%]+?))?\s*-?%}/g;

/**
* Matches element includes (as defined by creator), $1 is elementSettings, $2 is elementSettingNo , $3 is path, $4 is optional include with (in creator element.name)
*/
const LiquidIncludeHomePageElementRegex = /{%-?\s*if\s+settings\.(\S+)\s*==\s*"on"\s*-?%}\s*<div\s+style="order:{{settings\.(\S+)}}">[\s\S]*?{%-?\s*include\s+'(elements\/[^']+)'(?:\s+with\s+'([^']+)')?(?:\s+bannerName:\s*'([^']+)')?\s*-?%}\s*<\/div>\s*{%-?\s*endif\s*-?%}/g;

/**
 * creates regex that finds a block with a provided name
 * $1 should return the content
 * @param {string} blockName 
 */
function GetBlockRegex(blockName) {
    const regexText = `{%-?\\s+block\\s+${blockName}\\s+-%}([\\s\\S]*?){%-?\\s+endblock\\s+-?%}`;
    return new RegExp(regexText);
}

/**
 * creates regex for finding a template with specified name
 * $3 should return the content (will be undefined if tag is empty and instantly terminated ie. <Lqt_Tpl/>)
 * @param {string} templateName 
 */
function CreateGetTemplateContentRegex(templateName) {
    const regexText = `<Template\\s+[^>]*?\\sName=(['"])${templateName}\\1[^>]*?>\\s*<Lqt_Tpl(/|>(.*?)</Lqt_Tpl)>\\s*</Template>`;
    return new RegExp(regexText);
}

/**
 * gets content of <Templates>foo</Templates>
 * @param {string} xmlString liquid template xml in string form
 */
function GetTemplatesTagContent(xmlString) {
    const hasTemplates = TemplatesTagRegex.test(xmlString);
    if (!hasTemplates) {
        throw new Error('No <Templates> xml tag or it\'s empty');
    }

    const templatesTagContent = TemplatesTagRegex.exec(xmlString)[1];
    return templatesTagContent;
}

/**
 * returns a set of template names (XML: <Template .. Name="THIS"...>...)
 * @param {*} xmlString liquid template xml in string form
 */
export function GetTemplateNames(xmlString) {
    const templatesTagContent = GetTemplatesTagContent(xmlString);
    const templateNames = new Set();

    let match = undefined;
    while ((match = SingleTemplateRegex.exec(templatesTagContent)) !== null) {
        templateNames.add(match[2]);
    }
    return templateNames;
}

/** 
 * parses content from xml tag and decodes it if 
 * @param {string} xmlString liquid template xml in string form
 * @param {string} templateName name of template/file path
 * @param {boolean} isB64Encoded is true by default
 */
export function GetTemplateContent(xmlString, templateName, isB64Encoded = true) {
    const regex = CreateGetTemplateContentRegex(templateName);
    const match = regex.exec(xmlString);
    if (!match) {
        throw new Error(`$Template '${templateName}' doesn't exist or doesn't contain <Lqt_Tpl> tag`);
    }
    if (!match[3]) {
        return "";
    }
    if (isB64Encoded) {
        return atob(match[3]);
    } else {
        return match[3];
    }
}
/**
 * finds template in xml, extracts and decodes its content and only returns contents of {% block pageContent -%}
 * @param {string} xmlString 
 * @param {string} templateName 
 * @param {boolean} isB64Encoded 
 */
export function GetLiquidBlockContent(xmlString, templateName, blockName, isB64Encoded = true) {
    const content = GetTemplateContent(xmlString, templateName, isB64Encoded);
    const regex = GetBlockRegex(blockName);
    const newRegexBlockName = blockName.slice(0, blockName.search('Block'));
    const newRegex = new RegExp(`<-?${newRegexBlockName}[\\s\\S]*?>[\\s\\S]*?<-?/${newRegexBlockName}-?>`); // to catch header, becasue he is not splittet yet
    try {
        const match = regex.exec(content);
        if (!match) {
            const newMatch = newRegex.exec(content);
            if (!newMatch) {
                return "";
            }
            else {
                return newMatch[0];
            }
        }
        else {
            return match[1];
        }
    }
    catch (e) {
        return "";
    }
}

export function GetPageContentBlock(xmlString, templateName, isB64Encoded = true) {
    return GetLiquidBlockContent(xmlString, templateName, "pageContent", isB64Encoded);
}

// export function GetHeaderBlock(xmlString, templateName, isB64Encoded = true) {
//     return GetLiquidBlockContent(xmlString, templateName, "headerBlock", isB64Encoded);
// }

export function GetFooterBlock(xmlString, templateName, isB64Encoded = true) {
    return GetLiquidBlockContent(xmlString, templateName, "footerBlock", isB64Encoded);
}
/**
 * 
 * @param {string} pageContent 
 * @param {Map<String,String>} pluginConfigMap 
 */


//this function is used to check if user has deprecated template
export function ParseElementIncludesFromHomePageContentBlock(pageContent, pluginConfigMap) {
    if(LiquidIncludeHomePageElementRegex.exec(pageContent) === null) {
        return ParseElementIncludesFromContentBlock(pageContent, pluginConfigMap);
    } else {
        LiquidIncludeHomePageElementRegex.lastIndex = 0;
        return ParseElementIncludesFromOrderedContentBlock(pageContent, pluginConfigMap);
    }
}


export function ParseElementIncludesFromOrderedContentBlock(pageContent, pluginConfigMap) {
    const retval = [];
    let match = undefined;
    const elementMap = getElementMap();

    while ((match = LiquidIncludeHomePageElementRegex.exec(pageContent)) !== null) {
        const elementNo = getImportedTemplateSettings(match[2]);
        const path = match[3];
        const pathSplit = path.split('/');
        const type = pathSplit[1] ; 
        const id = pathSplit[2].slice(0, -5); //ensure it exists,ensure it has .html extension

        const tempobj = elementMap.get(`${type}/${id}`);
        if (!tempobj) {
            throw new Error("Undefined element");
        }
        const obj = { ...tempobj };
        const name = match[4] || null;
        if (name !== null) {
            obj.name = name;
        }
        obj.type = type;
        if (obj.name && pluginConfigMap.has(obj.name)) {
            obj.config = pluginConfigMap.get(obj.name);
        }
        retval.push({element: obj, index: elementNo});
    }
    
    return retval.sort((x, y) => x.index - y.index ).map(x => x.element);
}

function AdditionalParseElementRetvalArrayModifier(retval, elementType, tempObj, retvalModifier) {
    if (!retval.some(retvalElement => retvalElement.type === elementType)) {
        if (!tempObj) {
            throw new Error("Undefined element");
        }
        const obj = { ...tempObj };
        obj.type = elementType;
        retvalModifier(retval, obj, elementType);
    }
}

function AdditionalParseElementIncludesForColumn(element, templateTempContent, retval) {
    let listsNames = require('../../assets/defSites.json');
    let isParentAdded = false;
    if (templateTempContent) {
        listsNames = listsNames.filter(site => site.listName).map(listNameSite => listNameSite.listName);
        listsNames.forEach(list => {
            if (templateTempContent[list]?.some(listElement => listElement.id === element.id)) {
                isParentAdded = true;
            }
        });
        if (templateTempContent.header[0].id === element.id || templateTempContent.footer[0].id === element.id) {
            isParentAdded = true;
        }
    }
    if(!isParentAdded) { return; }
    if (element.column && Object.keys(element.column).length > 0) {
        const elementType = element.column.id.slice(0, element.column.id.lastIndexOf('-'));
        AdditionalParseElementRetvalArrayModifier(retval, elementType, element.column, (arr, obj, _elementType) => {
            if (obj.onTop) {
                arr.unshift(obj);
            }
            else {
                arr.push(obj);
            }
        });
    }
}

function AdditionalParseElementIncludesFromContentBlock(listName, retval, elementMap, templateTempContent) {
    if (listName === 'header') { //removed footer, because footerBlock exists now - when adding new headers it needs to be removed 
        const elementType = listName;
        AdditionalParseElementRetvalArrayModifier(retval, elementType, elementMap.get(`${elementType}/${elementType}-1`), (arr, obj, innerListName) => {
            if (obj[innerListName] && Object.keys(obj[innerListName]).length > 0) {
                obj[innerListName].type = obj[innerListName].id.slice(0, obj[innerListName].id.lastIndexOf('-'));
            }
            arr.push(obj);
        });
    } else if (listName === 'column') {
        elementMap.forEach(element => AdditionalParseElementIncludesForColumn(element, templateTempContent, retval));
    } else {
        console.warn("unexpected global element type definition in assets/elements.json, will not process");

        //probably unnecessary code after remove order and then add new one - not static

        // allowedElementsTypes = [...require('../../assets/elements.json').elementTypes[listName.slice(0, listName.length - 4)]];
        // allowedElementsTypes.pop();
        // allowedElementsTypes.shift();
        // if (listName === 'productListBody' && xmlLiquidSettings['nameGraphDescCategory'] === 'down') {
        //     allowedElementsTypes.splice(allowedElementsTypes.indexOf('categoryDescription'), 1);
        //     allowedElementsTypes.splice(allowedElementsTypes.indexOf('products-list') + 1, 0, 'categoryDescription');
        // }
        // allowedElementsTypes.forEach(elementType => {
        //     if (!retval.some(retvalElement => retvalElement.type === elementType)) {
        //         let filterElementMapKeys = [...elementMap.keys()].filter(mapKey => {
        //             let sliceMapKey = mapKey.slice(0, mapKey.indexOf('/'));
        //             return sliceMapKey.includes(elementType)
        //         });
        //         let tempObj = undefined;
        //         filterElementMapKeys.forEach(filterMapKey => {
        //             let filterElementMapSettings = Object.keys(elementMap.get(filterMapKey).settings).length > 0 ? JSON.parse(elementMap.get(filterMapKey).settings) : {};
        //             let noSettingsMatch = false;
        //             for (const [settingObjectKey, settingObjectValue] of Object.entries(filterElementMapSettings)) {
        //                 if (xmlLiquidSettings[settingObjectKey] && xmlLiquidSettings[settingObjectKey] !== settingObjectValue) {
        //                     noSettingsMatch = true;
        //                     break;
        //                 }
        //             }
        //             if (!noSettingsMatch) {
        //                 tempObj = elementMap.get(filterMapKey);
        //             }
        //         });
        //         if (!tempObj && filterElementMapKeys.length > 1) {
        //             tempObj = elementMap.get(filterElementMapKeys[0]);
        //         }
        //         if (!tempObj) return;
        //         let obj = Object.assign({}, tempObj);
        //         obj.type = elementType;
        //         if (obj.name && pluginConfigMap.has(obj.name)) {
        //             obj.config = pluginConfigMap.get(obj.name);
        //         }
        //         if (obj.order) {
        //             retval.splice(obj.order - 1, 0, obj);
        //         } else {
        //             retval.push(obj);    
        //         }
        //     }
        // });
    }
}

export function ParseElementIncludesFromContentBlock(pageContent, pluginConfigMap, listName = "", templateTempContent = null) {
    const retval = [];
    let match = undefined;
    const elementMap = getElementMap();
    // added LiquidIncludeElementRegex.lastIndex = 0; to reset the regular routine's index before changing usage. To allow exec() to calculate the search from the beginning of theContent page in creating a loop iteration.
    LiquidIncludeElementRegex.lastIndex = 0

    while ((match = LiquidIncludeElementRegex.exec(pageContent)) !== null) {
        const path = match[1];
        const pathSplit = path.split('/');
        let type;
        if (pathSplit[1] === "productsList") {
            type = "products-list";
        } else {
            type = pathSplit[1];
        }
        //ERROR FIX  //TODO add pageName arg, validate through it
        const id = pathSplit[2].slice(0, -5);//ensure it exists,ensure it has .html extension

        const tempobj = elementMap.get(`${type}/${id}`);
        if (!tempobj) {
            throw new Error("Undefined element");
        }
        const obj = { ...tempobj };
        let name = null;
        if (match[2]) {
            name = match[2].replace(/^['"]|['"]$/g, '').replace(/\s*-\s*$/, '');
        }
        if (name && name[name.length -1] === "'") {
            name = name.slice(0, -1);
        }
        if (name !== null) {
            obj.name = name;
        }
        obj.type = type;
        if (obj.name && pluginConfigMap.has(obj.name)) {
            obj.config = pluginConfigMap.get(obj.name);
        }
        retval.push(obj);
    }

    if ((match = LiquidIncludeElementRegex.exec(pageContent)) === null) {
        AdditionalParseElementIncludesFromContentBlock(listName, retval, elementMap, templateTempContent);
    }
    return retval;
}

export default { GetTemplateContent, GetTemplateNames, ParseElementIncludesFromContentBlock };